"use client" 
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { useState, useEffect } from "react";

const CandidateWorkspaceSideNavbar =({callback, lang}) => {

  const pathname = usePathname()
  const searchParams = useSearchParams()
  const search = searchParams.get('url')
  const [url, setUrl] = useState({})
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [currentNavId, setCurrentNavId] = useState(
    window.location.href.endsWith('/workspace') ? 1 : window.location.href.endsWith('/workspace/jobs') ? 3 : window.location.href.endsWith('/workspace/candidatures') ? 4 : window.location.href.endsWith('/workspace/settings') ? 10 : 0
  )
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);

  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    // Attach a click event listener to the document
    document.addEventListener("click", closeDropdown);

    setUrl({
      pathname: window.location.pathname.split(`/${lang}/`)[1] || '',
      search: window.location.search
      });

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", closeDropdown);
    };
  }, []);

  const handleDropdownClick = (e) => {
    // Prevent the click on the dropdown itself from triggering the closeDropdown
    e.stopPropagation();
  };

  const handleToggleClick = (e) => {
    e.stopPropagation();
    toggleDropdown();

  };

     return (
          
      <aside
      id="NavSidebar"
      className="fixed top-0 left-0 z-30 w-20 h-screen transition-transform bg-white border-r border-gray-200 sm:translate-x-0 dark:bg-gray-800 dark:border-gray-700"
      aria-label="NavSidebar"
    >

      {/* bg-gradient-to-t from-violet-700 via-violet-600 to-indigo-600  */}
      <div className="h-full bg-gray-50 dark:bg-gray-900 flex flex-col justify-between">
      {/* <div className="mx-auto pt-2 text-sm text-black dark:text-white dark:hover:text-gray-500 hover:text-gray-600 duration-300"> */}
<div className="mt-2">
      {/* <Link href={`employers/`}
              className={`transition duration-300 ease-in-out text-black dark:text-gray-200 flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 py-2`}>
              <span className="text-center mx-auto"><i className="fa-solid fa-binoculars items-center text-xl"></i><br/>
              {lang === 'fr' ? 'Votre Page' : 'Your Page'}</span>
            </Link>
 */}

      
      <Link 
            href={`/${lang === 'fr' ? `en/${url.pathname}${url.search}` : `fr/${url.pathname}${url.search}`}`}
              className={`transition duration-300 ease-in-out text-black dark:text-gray-200 flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 py-2`}>
              <span className="text-center mx-auto"><i className="fa-solid fa-globe items-center text-xl"></i><br/>
              {lang === 'fr' ? 'English' : 'Français'}</span>
            </Link>
</div>


      {/* <Link href={`/${lang === 'fr' ? `en/${url.pathname}${url.search}` : `fr/${url.pathname}${url.search}`}`}>
      <span className="text-center mx-auto"><i className="fa-solid fa-globe items-center text-xl"></i><br/>{lang === 'fr' ? 'English' : 'Français'}</span>
        </Link> */}
      {/* </div> */}
      
        {/* <div className="flex flex-col justify-center">

        </div> */}



        <ul>



<div className="text-black dark:text-gray-200">

            <Link 
              onClick={()=>setCurrentNavId(1)}
              href={`/${lang}/talent/workspace`}
              className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 ${currentNavId === 1 && 'bg-gray-200 dark:bg-slate-800 dark:hover:bg-slate-800'} py-2`}>
              <span className="text-center mx-auto">
                <i className="fa-solid fa-table-columns items-center text-xl"></i><br/>
                {lang === 'fr' ? 'Console' : 'Dashboard'}
              </span>
            </Link>

            <Link 
              onClick={()=>setCurrentNavId(3)}
              href={`/${lang}/talent/workspace/jobs`}
              className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 ${currentNavId === 3 && 'bg-gray-200 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-800'} py-2`}>
              <span className="text-center mx-auto"><i className="fa-regular fa-folder-open items-center text-xl"></i><br/>
              {lang === 'fr' ? 'Vos Offres' : 'Your Jobs'}
              </span>
            </Link>

          

            {/* <div className="text-gray-500 text-center">----</div> */}

         


</div>



          
          </ul>


        {/* BOTTOM */}
        <div className="text-black dark:text-gray-200 mb-2">

        <Link 
        onClick={()=>{callback({supportModalOpen: true})}}
        href={`#`}
        className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 ${currentNavId === 9 && 'bg-gray-200 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-800'} py-2`}>
        <span className="text-center mx-auto"><i className="fa-solid fa-comment text-xl"></i><br/>{lang === 'fr' ? 'Support' : 'Support'}</span>
      </Link>


        <Link 
        onClick={()=>setCurrentNavId(10)}
        href={`/${lang}/talent/workspace/settings`}
        className={`transition duration-300 ease-in-out flex text-xs leading-snug hover:bg-gray-200 dark:hover:bg-slate-800 ${currentNavId === 10 && 'bg-gray-200 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-800'} py-2`}>
        <span className="text-center mx-auto"><i className="fa-solid fa-gear text-xl"></i><br/>{lang === 'fr' ? 'Réglages' : 'Settings'}</span>
      </Link>



        {/* <Link 
          href="/admin/root"
          className="transition delay-10 duration-300 ease-in-out block bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 text-2xl rounded-lg m-1 dark:text-gray-200"
        >
          <li className="flex justify-center items-center py-2">
            <i className="fa-solid fa-cog"></i>
          </li>
        </Link> */}
</div>
        
      </div>
    </aside>

     )
}

export default CandidateWorkspaceSideNavbar